import { OrgRole } from '../../enums';
import mockedPaginatedResponse from './mockedPaginatedResponse';
import mockedRequester from './mockedRequester';
export const mockedMember = {
    id: 1,
    creationDate: '1',
    orgId: 1,
    role: OrgRole.admin,
    email: 'test@test.com',
    name: 'test'
};
const mock = {
    get: mockedRequester(mockedMember, 'members.get'),
    getMany: mockedRequester(mockedPaginatedResponse([mockedMember]), 'members.getMany'),
    getPage: mockedRequester(mockedPaginatedResponse([mockedMember]), 'members.getPage'),
    updateRole: mockedRequester(mockedMember, 'members.updateRole'),
    deletion: mockedRequester(undefined, 'members.deletion'),
    download: mockedRequester({}, 'invitations.sent.download')
};
export default mock;
